/**
 * JGQ — Calculateur livraison résidentielle (panier)
 * Distance: backend CRM → Google Distance Matrix → Haversine (estimation)
 */
(function () {
  'use strict';

  if (window.__jgqDeliveryCalcInit) return;
  window.__jgqDeliveryCalcInit = true;

  var WAREHOUSE = '1265, rue des Artisans, Québec, QC G1N 4T8, Canada';
  var API_DENIED_MSG = 'Le service de calcul de distance n\u2019est pas configur\u00e9. Contactez-nous ou choisissez la cueillette \u00e0 l\u2019entrep\u00f4t.';
  var FEE_VARIANT_MSG = 'Frais enregistr\u00e9s dans la commande. Configuration admin requise pour la facturation automatique (variant Frais de service \u00e0 1 $).';

  var TRANSPORT_TIERS = [
    { maxKm: 5, price: 100, label: '5 km' },
    { maxKm: 10, price: 125, label: '10 km' },
    { maxKm: 15, price: 150, label: '15 km' },
    { maxKm: 20, price: 175, label: '20 km' },
    { maxKm: 25, price: 200, label: '25 km' },
    { maxKm: 30, price: 225, label: '30 km' }
  ];

  var CONSUMABLE_KW = [
    'boisseur', 'mais souffle', 'hot-dog', 'hot dog', 'cones a barbe',
    'sachet de', 'sac de sable', 'sac de balle', 'consommable', 'sucre a',
    'solution moussante', 'nettoyage', 'remplissage', 'essence ', 'liquide moussant',
    'sac de service', 'base de slush', 'popcorn, sachet'
  ];
  var ACCESSORY_KW = ['rallonge', 'tapis de', 'parachute'];
  var SALE_KW = ['a vendre', 'usagee', 'usage -'];
  var FEE_KW = ['frais de service', 'frais de livraison'];

  var SERVICE_LABELS = {
    transport: 'Livraison et ramassage, sans montage',
    cle_en_main: 'Service clef en main',
    cueillette: 'Cueillette entrepôt (gratuit)'
  };

  var LEGACY_CART_ATTR_KEYS = [
    'Code postal livraison',
    'Palier transport',
    'Frais transport',
    'Frais installation',
    'Total frais service',
    'Distance (estimation)',
    'Adresse livraison',
    'Distance (km)'
  ];

  var MULTI_GAME_EXCLUDE_KW = [
    'barbe a papa', 'barbe à papa', 'machine barbe', 'machine a barbe',
    'popcorn', 'machine popcorn', 'machine a popcorn', 'machine à popcorn',
    'slush', 'machine slush', 'machine a slush'
  ];

  var EXTRA_GAME_FEE = 25;

  var installationIndex = null;
  var mapsLoading = false;
  var mapsCallbacks = [];
  var warehouseLatLng = null;

  function loadConfigFromDOM() {
    var root = document.querySelector('[data-jgq-delivery-calculator][data-maps-key]');
    if (!root) root = document.querySelector('[data-jgq-delivery-calculator]');
    if (!root) return {};
    return {
      googleMapsKey: root.getAttribute('data-maps-key') || '',
      warehouseAddress: root.getAttribute('data-warehouse') || WAREHOUSE,
      feeVariantId: root.getAttribute('data-fee-variant') || '',
      feeProductHandle: root.getAttribute('data-fee-handle') || 'frais-de-service-livraison',
      installationPricesUrl: root.getAttribute('data-prices-url') || ''
    };
  }

  function cfg() {
    window.jgqDeliveryConfig = Object.assign({}, window.jgqDeliveryConfig || {}, loadConfigFromDOM());
    return window.jgqDeliveryConfig;
  }

  function normalizeTitle(s) {
    if (!s) return '';
    return s.toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function stripVariantSuffix(title) {
    return (title || '')
      .replace(/\s*[-–—]\s*résidentiel.*$/i, '')
      .replace(/\s*[-–—]\s*residentiel.*$/i, '')
      .replace(/\s*[-–—]\s*corporatif.*$/i, '')
      .replace(/\s*[-–—]\s*\d+\s*pieds.*$/i, '')
      .trim();
  }

  function containsKw(title, list) {
    var t = normalizeTitle(title);
    for (var i = 0; i < list.length; i++) {
      if (t.indexOf(normalizeTitle(list[i])) >= 0) return true;
    }
    return false;
  }

  function isDeliveryFeeItem(item) {
    if (item.properties && (item.properties._delivery_fee === 'true' || item.properties._delivery_fee === true)) return true;
    return containsKw(item.product_title || item.title, FEE_KW);
  }

  function isExcludedFromInstallation(item) {
    if (isDeliveryFeeItem(item)) return true;
    var title = item.product_title || item.title || '';
    return containsKw(title, CONSUMABLE_KW) || containsKw(title, ACCESSORY_KW) || containsKw(title, SALE_KW);
  }

  function isExcludedFromMultiGameFee(item) {
    if (isDeliveryFeeItem(item)) return true;
    if (!isResidentialItem(item)) return true;
    if (isExcludedFromInstallation(item)) return true;
    var title = item.product_title || item.title || '';
    return containsKw(title, MULTI_GAME_EXCLUDE_KW);
  }

  function countEligibleGameUnits(cartItems) {
    var total = 0;
    (cartItems || []).forEach(function (item) {
      if (!isExcludedFromMultiGameFee(item)) {
        total += item.quantity || 1;
      }
    });
    return total;
  }

  function isResidentialItem(item) {
    if (isDeliveryFeeItem(item)) return false;
    var parts = [
      item.variant_title,
      item.product_title,
      item.title,
      item.product_type
    ].filter(Boolean).join(' ');
    var t = normalizeTitle(parts);
    if (t.indexOf('corporatif') >= 0 || t.indexOf('commercial') >= 0) return false;
    return t.indexOf('residentiel') >= 0;
  }

  function loadInstallationIndex(callback) {
    if (installationIndex) {
      callback(installationIndex);
      return;
    }
    var url = cfg().installationPricesUrl;
    if (!url) {
      installationIndex = {};
      callback(installationIndex);
      return;
    }
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        installationIndex = {};
        (data.products || []).forEach(function (entry) {
          (entry.names || []).forEach(function (name) {
            installationIndex[normalizeTitle(name)] = entry.price;
          });
        });
        callback(installationIndex);
      })
      .catch(function () {
        installationIndex = {};
        callback(installationIndex);
      });
  }

  function lookupInstallationPrice(item, index) {
    var baseTitle = stripVariantSuffix(item.product_title || item.title || '');
    var norm = normalizeTitle(baseTitle);
    if (index[norm] != null) return { price: index[norm], source: 'table' };

    var best = null;
    Object.keys(index).forEach(function (key) {
      if (norm.indexOf(key) >= 0 || key.indexOf(norm) >= 0) {
        if (!best || key.length > best.key.length) best = { key: key, price: index[key] };
      }
    });
    if (best) return { price: best.price, source: 'alias' };

    var priceBeforeTax = (item.original_price != null ? item.original_price : item.price) / 100;
    return { price: Math.round(priceBeforeTax * 0.3), source: 'fallback_30pct' };
  }

  function getTransportTier(km) {
    if (km > 30) return null;
    for (var i = 0; i < TRANSPORT_TIERS.length; i++) {
      if (km <= TRANSPORT_TIERS[i].maxKm) return TRANSPORT_TIERS[i];
    }
    return null;
  }

  function parseVariantId(raw) {
    if (!raw) return 0;
    var s = String(raw).trim();
    var m = s.match(/(\d+)\s*$/);
    return m ? parseInt(m[1], 10) : (parseInt(s, 10) || 0);
  }

  var feeVariantCache = null;

  /** Résout l'ID variant via le handle produit (évite confusion ID produit vs variant). */
  function resolveFeeVariantId() {
    if (feeVariantCache) return Promise.resolve(feeVariantCache);

    var configured = parseVariantId(cfg().feeVariantId);
    var handle = (cfg().feeProductHandle || 'frais-de-service-livraison').trim();

    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('fee_product_not_found');
        return r.json();
      })
      .then(function (product) {
        var variants = product.variants || [];
        var variant = variants[0];
        if (!variant || !variant.id) {
          throw new Error('fee_variant_missing');
        }

        if (configured && variants.some(function (v) { return v.id === configured; })) {
          feeVariantCache = configured;
        } else if (configured && String(configured) === String(product.id)) {
          feeVariantCache = variant.id;
        } else if (configured) {
          feeVariantCache = variant.id;
        } else {
          feeVariantCache = variant.id;
        }

        window.jgqDeliveryConfig = window.jgqDeliveryConfig || {};
        window.jgqDeliveryConfig.resolvedFeeVariantId = feeVariantCache;
        window.jgqDeliveryConfig.feeVariantAvailable = !!variant.available;

        return feeVariantCache;
      })
      .catch(function () {
        if (configured) {
          feeVariantCache = configured;
          return configured;
        }
        return 0;
      });
  }

  function mapsApiReady() {
    return typeof google !== 'undefined' && google.maps;
  }

  function waitForGoogleMaps(maxWait, callback) {
    var elapsed = 0;
    var step = 200;
    function tick() {
      if (mapsApiReady()) return callback();
      elapsed += step;
      if (elapsed >= maxWait) return callback(new Error('Google Maps indisponible'));
      setTimeout(tick, step);
    }
    tick();
  }

  function ensureGoogleMaps(callback) {
    if (mapsApiReady()) {
      callback();
      return;
    }

    var existing = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
    if (existing) {
      waitForGoogleMaps(8000, callback);
      return;
    }

    mapsCallbacks.push(callback);
    if (mapsLoading) return;
    mapsLoading = true;

    var key = cfg().googleMapsKey;
    if (!key) {
      mapsLoading = false;
      var cbs = mapsCallbacks.splice(0);
      cbs.forEach(function (cb) { cb(new Error('Cl\u00e9 Google Maps manquante')); });
      return;
    }

    var script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&libraries=places&language=fr&region=ca&loading=async';
    script.async = true;
    script.defer = true;
    script.onload = function () {
      mapsLoading = false;
      waitForGoogleMaps(5000, function (err) {
        var cbs = mapsCallbacks.splice(0);
        cbs.forEach(function (cb) { cb(err); });
      });
    };
    script.onerror = function () {
      mapsLoading = false;
      mapsCallbacks.splice(0).forEach(function (cb) { cb(new Error('Google Maps indisponible')); });
    };
    document.head.appendChild(script);
  }

  function ensurePlaces(callback) {
    ensureGoogleMaps(function (err) {
      if (err) return callback(err);
      if (google.maps.places) return callback();
      var elapsed = 0;
      function tick() {
        if (google.maps.places) return callback();
        elapsed += 200;
        if (elapsed >= 5000) return callback(new Error('Autocomplete indisponible'));
        setTimeout(tick, 200);
      }
      tick();
    });
  }

  function geocodeAddress(address) {
    return new Promise(function (resolve, reject) {
      ensureGoogleMaps(function (err) {
        if (err) return reject(err);
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: address, region: 'CA' }, function (results, status) {
          if (status !== 'OK' || !results || !results[0]) {
            return reject(new Error('Adresse introuvable'));
          }
          resolve(results[0].geometry.location);
        });
      });
    });
  }

  function haversineKm(lat1, lng1, lat2, lng2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLng = (lng2 - lng1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function getWarehouseLatLng() {
    if (warehouseLatLng) return Promise.resolve(warehouseLatLng);
    var origin = cfg().warehouseAddress || WAREHOUSE;
    return geocodeAddress(origin).then(function (loc) {
      warehouseLatLng = { lat: loc.lat(), lng: loc.lng() };
      return warehouseLatLng;
    });
  }

  function getDistanceFromGoogleMatrix(destination) {
    return new Promise(function (resolve, reject) {
      ensureGoogleMaps(function (err) {
        if (err) return reject(err);
        if (!google.maps.DistanceMatrixService) {
          return reject(new Error('Distance Matrix non disponible'));
        }
        var origin = cfg().warehouseAddress || WAREHOUSE;
        var service = new google.maps.DistanceMatrixService();
        service.getDistanceMatrix({
          origins: [origin],
          destinations: [destination],
          travelMode: google.maps.TravelMode.DRIVING,
          unitSystem: google.maps.UnitSystem.METRIC
        }, function (response, status) {
          if (status !== 'OK') {
            return reject(new Error(status === 'REQUEST_DENIED' ? API_DENIED_MSG : 'Impossible de calculer la distance'));
          }
          var el = response.rows[0] && response.rows[0].elements[0];
          if (!el) return reject(new Error('Adresse introuvable'));
          if (el.status === 'REQUEST_DENIED') return reject(new Error(API_DENIED_MSG));
          if (el.status !== 'OK') return reject(new Error('Adresse introuvable ou hors route'));
          resolve({
            km: Math.ceil((el.distance.value / 1000) * 10) / 10,
            source: 'google_matrix',
            estimated: false
          });
        });
      });
    });
  }

  function getDistanceHaversine(destination) {
    return getWarehouseLatLng().then(function (wh) {
      return geocodeAddress(destination).then(function (loc) {
        var km = haversineKm(wh.lat, wh.lng, loc.lat(), loc.lng());
        return {
          km: Math.ceil(km * 10) / 10,
          source: 'haversine',
          estimated: true
        };
      });
    });
  }

  function getDrivingDistanceKm(destination) {
    return withTimeout(
      getDistanceFromGoogleMatrix(destination).catch(function () { return getDistanceHaversine(destination); }),
      25000,
      'Calcul de distance trop long. R\u00e9essayez ou choisissez la cueillette.'
    );
  }

  function initAutocomplete(input) {
    if (!input || input.dataset.jgqAcInit) return;
    ensurePlaces(function (err) {
      if (err || !mapsApiReady() || !google.maps.places) return;
      input.dataset.jgqAcInit = '1';
      input.setAttribute('autocomplete', 'off');
      var ac = new google.maps.places.Autocomplete(input, {
        types: ['geocode'],
        componentRestrictions: { country: 'ca' }
      });
      ac.addListener('place_changed', function () {
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') e.preventDefault();
      });
    });
  }

  function calculateQuote(serviceType, distanceKm, cartItems, index, distanceMeta) {
    if (serviceType === 'cueillette') {
      return {
        success: true,
        distance_km: 0,
        transport_price: 0,
        installation_total: 0,
        extra_game_fee: 0,
        extra_game_count: 0,
        total_price: 0,
        breakdown: { transport_tier: 'Cueillette entrepôt', installation_lines: [] },
        out_of_zone: false,
        distance_estimated: false
      };
    }

    var tier = getTransportTier(distanceKm);
    if (!tier) {
      return { success: false, out_of_zone: true, error: 'OUT_OF_ZONE' };
    }

    var transport = tier.price;
    var installationTotal = 0;
    var lines = [];

    if (serviceType === 'cle_en_main') {
      cartItems.forEach(function (item) {
        if (!isResidentialItem(item) || isExcludedFromInstallation(item)) return;
        var lookup = lookupInstallationPrice(item, index);
        var lineTotal = lookup.price * item.quantity;
        installationTotal += lineTotal;
        lines.push({
          title: stripVariantSuffix(item.product_title || item.title),
          price: lookup.price,
          quantity: item.quantity,
          line_total: lineTotal,
          source: lookup.source
        });
      });
    }

    var extraGameFee = 0;
    var extraGameCount = 0;
    if (serviceType === 'transport') {
      var eligibleUnits = countEligibleGameUnits(cartItems);
      extraGameCount = Math.max(0, eligibleUnits - 1);
      extraGameFee = extraGameCount * EXTRA_GAME_FEE;
    }

    return {
      success: true,
      distance_km: distanceKm,
      transport_price: transport,
      installation_total: installationTotal,
      extra_game_fee: extraGameFee,
      extra_game_count: extraGameCount,
      total_price: transport + installationTotal + extraGameFee,
      breakdown: {
        transport_tier: tier.label,
        installation_lines: lines
      },
      out_of_zone: false,
      distance_estimated: distanceMeta && distanceMeta.estimated
    };
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) {
      if (!r.ok) throw new Error('Impossible de lire le panier');
      return r.json();
    });
  }

  function withTimeout(promise, ms, message) {
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () {
        reject(new Error(message || 'D\u00e9lai d\u2019attente d\u00e9pass\u00e9'));
      }, ms);
      promise.then(function (v) {
        clearTimeout(timer);
        resolve(v);
      }).catch(function (e) {
        clearTimeout(timer);
        reject(e);
      });
    });
  }

  function removeDeliveryFeeLines(cart) {
    var feeLines = [];
    cart.items.forEach(function (item, i) {
      if (isDeliveryFeeItem(item)) feeLines.push(i + 1);
    });
    if (!feeLines.length) return Promise.resolve(cart);
    feeLines.sort(function (a, b) { return b - a; });
    return feeLines.reduce(function (chain, line) {
      return chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: 0 })
        }).then(function (r) { return r.json(); });
      });
    }, Promise.resolve(cart));
  }

  function buildCartAttributes(quote, serviceType, address) {
    var attrs = { 'Service livraison': SERVICE_LABELS[serviceType] || serviceType };

    LEGACY_CART_ATTR_KEYS.forEach(function (key) {
      attrs[key] = '';
    });

    if (serviceType !== 'cueillette') {
      attrs['Adresse livraison'] = address || '';
      attrs['Distance (km)'] = String(quote.distance_km || 0);
    }

    return attrs;
  }

  function formatCartMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return (cents / 100).toLocaleString('fr-CA', { style: 'currency', currency: 'CAD' });
  }

  function serviceTypeFromAttrs(attrs) {
    var label = (attrs['Service livraison'] || '').toLowerCase();
    if (label.indexOf('cueillette') >= 0) return 'cueillette';
    if (label.indexOf('sans montage') >= 0) return 'transport';
    if (label.indexOf('clef en main') >= 0 || label.indexOf('clé en main') >= 0) return 'cle_en_main';
    if (label.indexOf('montage') >= 0 || label.indexOf('démontage') >= 0) return 'cle_en_main';
    if (label.indexOf('livraison') >= 0) return 'transport';
    return null;
  }

  function totalFromFeeLine(cart) {
    var total = 0;
    if (!cart || !cart.items) return total;
    cart.items.forEach(function (item) {
      if (isDeliveryFeeItem(item)) total = item.quantity || 0;
    });
    return total;
  }

  function quoteFromAttrs(attrs, cart) {
    if (!attrs['Service livraison']) return null;
    return {
      success: true,
      distance_km: parseFloat(attrs['Distance (km)']) || 0,
      transport_price: 0,
      installation_total: 0,
      extra_game_fee: 0,
      extra_game_count: 0,
      total_price: totalFromFeeLine(cart),
      breakdown: { installation_lines: [] },
      distance_estimated: false
    };
  }

  function persistQuoteState(quote, serviceType, address, postal) {
    window.jgqDeliveryState = {
      valid: true,
      pending: false,
      serviceType: serviceType,
      total: quote.total_price,
      quote: quote,
      address: address || '',
      postal: postal || ''
    };
    saveDeliveryChoice(serviceType, false, true);
  }

  function restoreCalculatorUI(root) {
    if (!root) return;
    var state = window.jgqDeliveryState;
    if (!state || !state.valid || !state.quote) return;

    root.hidden = false;
    root.classList.add('is-visible');

    var options = root.querySelectorAll('[data-jgq-delivery-option]');
    options.forEach(function (btn) {
      var on = btn.dataset.jgqDeliveryOption === state.serviceType;
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var addressWrap = root.querySelector('[data-jgq-delivery-address-wrap]');
    var addressInput = root.querySelector('[data-jgq-delivery-address]');
    var postalInput = root.querySelector('[data-jgq-delivery-postal]');
    var resultEl = root.querySelector('[data-jgq-delivery-result]');

    if (addressWrap) {
      addressWrap.hidden = state.serviceType === 'cueillette';
    }
    if (addressInput && state.address && state.serviceType !== 'cueillette') {
      addressInput.value = state.address.replace(/^Cueillette —.*$/, '').trim() || state.address;
    }
    if (postalInput && state.postal) postalInput.value = state.postal;
    if (resultEl) renderBreakdown(resultEl, state.quote, state.serviceType);
  }

  function restoreFromCartAttributes(root, cart) {
    var attrs = cart.attributes || {};
    var serviceType = serviceTypeFromAttrs(attrs);
    var quote = quoteFromAttrs(attrs, cart);
    if (!serviceType || !quote) return;

    var isDelivery = serviceType === 'transport' || serviceType === 'cle_en_main';
    var hasAddress = String(attrs['Adresse livraison'] || '').trim().length >= 5;
    var hasDistance = String(attrs['Distance (km)'] || '').trim() !== '';
    var complete = !isDelivery || (hasAddress && hasDistance);

    window.jgqDeliveryState = {
      valid: complete,
      pending: isDelivery && !complete,
      serviceType: serviceType,
      total: quote.total_price,
      quote: quote,
      address: attrs['Adresse livraison'] || '',
      postal: ''
    };
    saveDeliveryChoice(serviceType, isDelivery && !complete, complete);
    restoreCalculatorUI(root);
  }

  /** Met à jour sous-total + lignes panier sans toucher au calculateur */
  function refreshCartUI(cart) {
    if (!cart) return Promise.resolve();

    document.querySelectorAll('.totals__subtotal-value').forEach(function (el) {
      el.textContent = formatCartMoney(cart.total_price);
    });

    var itemsEl = document.getElementById('main-cart-items');
    if (!itemsEl || !itemsEl.dataset.id) {
      return Promise.resolve(cart);
    }

    return fetch(window.location.pathname + '?sections=' + itemsEl.dataset.id)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[itemsEl.dataset.id];
        if (!html) return cart;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var target = itemsEl.querySelector('.js-contents');
        var source = parsed.querySelector('.js-contents');
        if (target && source) target.innerHTML = source.innerHTML;
        return cart;
      })
      .catch(function () { return cart; });
  }

  function refreshCartUISafe(cart) {
    return withTimeout(refreshCartUI(cart), 8000, null).catch(function () { return cart; });
  }

  function applyToCart(quote, serviceType, address, postal) {
    var attrs = buildCartAttributes(quote, serviceType, address);

    function parseCartResponse(r) {
      return r.json().then(function (data) {
        if (!r.ok || (data.status && data.status >= 400)) {
          var msg = data.description || data.message || 'Erreur panier';
          if (/sold out|épuisé|stock|available/i.test(msg)) {
            msg = 'Le produit « Frais de service » est indisponible dans Shopify. Admin → Produit → Inventaire : cochez « Continuer la vente en cas de rupture » ou désactivez le suivi des stocks.';
          }
          throw new Error(msg);
        }
        return data;
      });
    }

    return resolveFeeVariantId()
      .then(function (variantId) {
        if (quote.total_price > 0 && !variantId) {
          throw new Error('Produit « Frais de service — Livraison » introuvable. Vérifiez qu\'il est publié sur la Boutique en ligne.');
        }
        if (window.jgqDeliveryConfig && window.jgqDeliveryConfig.feeVariantAvailable === false && quote.total_price > 0) {
          throw new Error('Le produit « Frais de service » est marqué indisponible. Admin Shopify → Inventaire → « Continuer la vente en cas de rupture de stock ».');
        }

        return fetchCart()
          .then(removeDeliveryFeeLines)
          .then(function (cart) {
            var merged = Object.assign({}, cart.attributes || {}, attrs);
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: merged })
            }).then(parseCartResponse);
          })
          .then(function (cart) {
            if (quote.total_price <= 0 || !variantId) return cart;
            var feeProps = {
              _delivery_fee: 'true',
              'Service': attrs['Service livraison']
            };
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{
                  id: variantId,
                  quantity: quote.total_price,
                  properties: feeProps
                }]
              })
            }).then(parseCartResponse);
          });
      })
      .then(function () { return fetchCart(); })
      .then(function (cart) { return refreshCartUISafe(cart); })
      .then(function () {
        var root = document.querySelector('[data-jgq-delivery-calculator]');
        if (root) {
          root.hidden = false;
          root.classList.add('is-visible');
          restoreCalculatorUI(root);
        }
      });
  }

  function formatMoney(dollars) {
    return dollars.toLocaleString('fr-CA', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' $';
  }

  function renderBreakdown(container, quote, serviceType) {
    var html = '';
    if (serviceType === 'cueillette') {
      html += '<p class="jgq-delivery-calc__line"><strong>Cueillette \u00e0 l\u2019entrep\u00f4t :</strong> Gratuit</p>';
      html += '<p class="jgq-delivery-calc__hint">1265, rue des Artisans, Qu\u00e9bec G1N 4T8</p>';
      html += '<p class="jgq-delivery-calc__total">Total frais de service : ' + formatMoney(quote.total_price) + ' + taxes</p>';
    } else if (serviceType === 'cle_en_main') {
      html += '<p class="jgq-delivery-calc__line"><strong>Transport seulement :</strong> ' + formatMoney(quote.transport_price) + ' + taxes</p>';
      html += '<p class="jgq-delivery-calc__line"><strong>Montage et D\u00e9montage :</strong> ' + formatMoney(quote.installation_total) + ' + taxes</p>';
      html += '<p class="jgq-delivery-calc__total">Total service clef en main : ' + formatMoney(quote.total_price) + ' + taxes</p>';
    } else {
      html += '<p class="jgq-delivery-calc__line"><strong>Transport :</strong> ' + formatMoney(quote.transport_price) + ' + taxes</p>';
      if (quote.extra_game_fee > 0) {
        html += '<p class="jgq-delivery-calc__line"><strong>Jeux suppl\u00e9mentaires :</strong> ' +
          quote.extra_game_count + ' \u00d7 ' + formatMoney(EXTRA_GAME_FEE) + ' = ' + formatMoney(quote.extra_game_fee) + ' + taxes</p>';
      }
      html += '<p class="jgq-delivery-calc__total">Total frais de service : ' + formatMoney(quote.total_price) + ' + taxes</p>';
    }
    html += '<p class="jgq-delivery-calc__note">Ces frais n\u2019incluent pas la location de l\u2019\u00e9quipement.</p>';
    container.innerHTML = html;
    container.hidden = false;
  }

  function bindCalculator(root) {
    if (!root || root.dataset.jgqBound) return;
    root.dataset.jgqBound = '1';

    cfg();

    var options = root.querySelectorAll('[data-jgq-delivery-option]');
    var addressWrap = root.querySelector('[data-jgq-delivery-address-wrap]');
    var addressInput = root.querySelector('[data-jgq-delivery-address]');
    var postalInput = root.querySelector('[data-jgq-delivery-postal]');
    var calcBtn = root.querySelector('[data-jgq-delivery-calculate]');
    var resultEl = root.querySelector('[data-jgq-delivery-result]');
    var errorEl = root.querySelector('[data-jgq-delivery-error]');
    var loadingEl = root.querySelector('[data-jgq-delivery-loading]');

    var selectedService =
      (window.jgqDeliveryState && window.jgqDeliveryState.serviceType) || 'cueillette';

    function syncSelectedService() {
      if (!selectedService) selectedService = 'cueillette';
      if (window.jgqDeliveryState && window.jgqDeliveryState.serviceType) {
        selectedService = window.jgqDeliveryState.serviceType;
      }
      options.forEach(function (b) {
        var on = b.dataset.jgqDeliveryOption === selectedService;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      updateAddressVisibility();
      if (calcBtn) {
        // Cueillette : pas besoin du bouton Calculer
        calcBtn.hidden = selectedService === 'cueillette';
      }
    }

    function selectService(service, opts) {
      opts = opts || {};
      selectedService = service;
      var isPickup = service === 'cueillette';
      var isDelivery = service === 'transport' || service === 'cle_en_main';

      saveDeliveryChoice(service, isDelivery, isPickup);
      syncSelectedService();
      setError('');
      if (resultEl && !isPickup) resultEl.hidden = true;

      if (isPickup && opts.apply !== false) {
        applyDefaultCueilletteQuiet();
        return;
      }

      if (isDelivery) {
        // Remplace immédiatement « cueillette » dans le panier → le checkout voit la vraie intention
        syncServiceAttributeToCart(service, true).catch(function () {});
        if (addressInput) addressInput.value = '';
        if (postalInput) postalInput.value = '';
      }
    }

    function applyDefaultCueilletteQuiet() {
      fetchCart()
        .then(function (cart) {
          var quote = calculateQuote('cueillette', 0, cart.items || [], {});
          persistQuoteState(quote, 'cueillette', '', '');
          return applyToCart(quote, 'cueillette', '', '').then(function () {
            if (resultEl) {
              renderBreakdown(resultEl, quote, 'cueillette');
            }
            syncSelectedService();
          });
        })
        .catch(function () {
          // State local suffit pour le checkout même si le panier n'a pas persisté
          persistQuoteState(calculateQuote('cueillette', 0, [], {}), 'cueillette', '', '');
          syncSelectedService();
        });
    }

    initAutocomplete(addressInput);

    function setError(msg) {
      if (!errorEl) return;
      if (msg) {
        errorEl.textContent = msg;
        errorEl.hidden = false;
      } else {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
    }

    function setLoading(on) {
      if (loadingEl) loadingEl.hidden = !on;
      if (calcBtn) calcBtn.disabled = on;
    }

    function updateAddressVisibility() {
      var needsAddress = selectedService === 'transport' || selectedService === 'cle_en_main';
      if (addressWrap) addressWrap.hidden = !needsAddress;
    }

    options.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectService(btn.dataset.jgqDeliveryOption, { apply: true });
      });
    });

    function runCalculate() {
      setError('');
      if (!selectedService && window.jgqDeliveryState && window.jgqDeliveryState.serviceType) {
        selectedService = window.jgqDeliveryState.serviceType;
      }
      if (!selectedService) {
        selectedService = 'cueillette';
      }
      if (selectedService === 'cueillette') {
        applyDefaultCueilletteQuiet();
        return;
      }

      setLoading(true);
      cfg();

      loadInstallationIndex(function (index) {
        fetchCart().then(function (cart) {
          var residentialItems = cart.items.filter(isResidentialItem);
          if (!residentialItems.length) {
            setError('Aucun article r\u00e9sidentiel dans le panier.');
            setLoading(false);
            return;
          }

          var address = addressInput ? addressInput.value.trim() : '';
          var postal = postalInput ? postalInput.value.trim().toUpperCase() : '';

          function finish(quote) {
            if (!quote.success) {
              if (quote.out_of_zone) {
                setError('Adresse hors de notre zone de service r\u00e9sidentiel (30 km). Contactez-nous au (418) 627-4348 ou bonheur@jeugonflablequebec.ca.');
              } else {
                setError('Impossible de calculer le prix. V\u00e9rifiez l\u2019adresse.');
              }
              return;
            }

            renderBreakdown(resultEl, quote, selectedService);
            persistQuoteState(quote, selectedService, address, postal);
            window.jgqDeliveryState.pending = false;
            return applyToCart(quote, selectedService, address, postal)
              .then(function () {
                restoreCalculatorUI(root);
                syncSelectedService();
                var feeId = parseVariantId(cfg().feeVariantId);
                if (!feeId && quote.total_price > 0) {
                  setError(FEE_VARIANT_MSG);
                } else {
                  setError('');
                }
              })
              .catch(function (err) {
                var vid = parseVariantId(cfg().feeVariantId);
                var msg = err.message || 'Erreur lors de la mise \u00e0 jour du panier.';
                if (/variant/i.test(msg) && vid) {
                  msg += ' (ID configur\u00e9 : ' + vid + ' — v\u00e9rifiez Th\u00e8me \u2192 Param\u00e8tres \u2192 Panier)';
                }
                setError(msg);
              });
          }

          var flow;
          if (!address || address.length < 5) {
            setError('Entrez une adresse de livraison valide.');
            flow = Promise.resolve();
          } else {
            var dest = address + (postal ? ', ' + postal : '') + ', Canada';
            flow = getDrivingDistanceKm(dest)
              .then(function (meta) {
                return finish(calculateQuote(selectedService, meta.km, cart.items, index, meta));
              })
              .catch(function (err) {
                setError(err.message || 'Impossible de calculer la distance.');
              });
          }

          Promise.resolve(flow).finally(function () { setLoading(false); });
        }).catch(function () {
          setError('Impossible de lire le panier. D\u00e9sactivez le bloqueur de tracking ou r\u00e9essayez.');
          setLoading(false);
        });
      });
    }

    if (calcBtn) calcBtn.addEventListener('click', runCalculate);

    // Init : session pending > attributs panier > défaut cueillette
    fetchCart()
      .then(function (cart) {
        var stored = loadDeliveryChoice();
        var existing = serviceTypeFromAttrs(cart.attributes || {});

        // Choix livraison en cours (session) prime sur cueillette encore en attributs
        if (
          stored &&
          (stored.serviceType === 'transport' || stored.serviceType === 'cle_en_main') &&
          stored.pending
        ) {
          selectedService = stored.serviceType;
          saveDeliveryChoice(stored.serviceType, true, false);
          syncSelectedService();
          syncServiceAttributeToCart(stored.serviceType, true).catch(function () {});
          return;
        }

        if (existing) {
          restoreFromCartAttributes(root, cart);
          selectedService = existing;
          syncSelectedService();
          return;
        }
        if (window.jgqDeliveryState && window.jgqDeliveryState.valid && window.jgqDeliveryState.serviceType) {
          selectedService = window.jgqDeliveryState.serviceType;
          syncSelectedService();
          return;
        }
        selectService('cueillette', { apply: true });
      })
      .catch(function () {
        var stored = loadDeliveryChoice();
        if (stored && stored.serviceType) {
          selectedService = stored.serviceType;
          saveDeliveryChoice(stored.serviceType, !!stored.pending, !!stored.valid);
          syncSelectedService();
          return;
        }
        selectService('cueillette', { apply: false });
        persistQuoteState(calculateQuote('cueillette', 0, [], {}), 'cueillette', '', '');
        syncSelectedService();
      });
  }

  function initOnce() {
    var root = document.querySelector('[data-jgq-delivery-calculator]');
    if (!root || root.dataset.jgqBound) return;

    cfg();

    function showAndBind(cart) {
      var isRes = cart && cart.items && cart.items.some(isResidentialItem);
      var hasConfig = cart && cart.attributes && cart.attributes['Service livraison'];
      var shouldShow = isRes || hasConfig || (window.jgqDeliveryState && window.jgqDeliveryState.valid)
        || root.classList.contains('is-visible');

      if (!shouldShow) {
        root.hidden = true;
        root.classList.remove('is-visible');
        return;
      }

      root.hidden = false;
      root.classList.add('is-visible');
      bindCalculator(root);
    }

    fetchCart().then(showAndBind).catch(function () {
      if (root.classList.contains('is-visible') || (window.jgqDeliveryState && window.jgqDeliveryState.valid)) {
        root.hidden = false;
        root.classList.add('is-visible');
        bindCalculator(root);
      }
    });
  }

  function checkResidential(callback) {
    fetchCart().then(function (cart) {
      var isRes = cart.items.some(isResidentialItem);
      var hasConfig = !!(cart.attributes && cart.attributes['Service livraison']);
      callback(isRes || hasConfig);
    }).catch(function () {
      callback(!!(window.jgqDeliveryState && window.jgqDeliveryState.valid));
    });
  }

  function saveDeliveryChoice(serviceType, pending, valid) {
    var payload = {
      serviceType: serviceType || 'cueillette',
      pending: !!pending,
      valid: !!valid,
      ts: Date.now()
    };
    window.jgqDeliveryState = Object.assign({}, window.jgqDeliveryState || {}, payload);
    try {
      sessionStorage.setItem('jgq_delivery_choice', JSON.stringify(payload));
    } catch (e) {}
  }

  function loadDeliveryChoice() {
    try {
      var raw = sessionStorage.getItem('jgq_delivery_choice');
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  /** Écrit le service au panier immédiatement (évite que « cueillette » reste en attribut). */
  function syncServiceAttributeToCart(serviceType, clearAddress) {
    var label = SERVICE_LABELS[serviceType] || serviceType;
    var attrs = { 'Service livraison': label };
    if (clearAddress) {
      attrs['Adresse livraison'] = '';
      attrs['Distance (km)'] = '';
      LEGACY_CART_ATTR_KEYS.forEach(function (key) {
        if (key !== 'Adresse livraison' && key !== 'Distance (km)') {
          attrs[key] = '';
        }
      });
    }
    return fetchCart().then(function (cart) {
      var merged = Object.assign({}, cart.attributes || {}, attrs);
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: merged })
      }).then(function (r) {
        return r.json();
      });
    });
  }

  function getUiSelectedDeliveryService() {
    var btn = document.querySelector(
      '[data-jgq-delivery-option].is-selected, [data-jgq-delivery-option][aria-pressed="true"]'
    );
    return btn ? String(btn.getAttribute('data-jgq-delivery-option') || '') : '';
  }

  function resolveChosenService(attrs) {
    var ui = getUiSelectedDeliveryService();
    var state = window.jgqDeliveryState || {};
    var stored = loadDeliveryChoice() || {};
    var fromAttrs = serviceTypeFromAttrs(attrs || {});
    // Priorité : UI cliquée → state → session → attributs panier → défaut cueillette
    return ui || state.serviceType || stored.serviceType || fromAttrs || 'cueillette';
  }

  function deliveryCalcIsComplete(attrs) {
    var address = String((attrs && attrs['Adresse livraison']) || '').trim();
    var distance = String((attrs && attrs['Distance (km)']) || '').trim();
    return address.length >= 5 && distance !== '';
  }

  /**
   * Défaut cueillette → OK.
   * Transport / clé-en-main → Adresse + Distance (km) obligatoires dans les attributs panier.
   */
  function validateBeforeCheckout(callback) {
    fetchCart()
      .then(function (cart) {
        var attrs = cart.attributes || {};
        var serviceType = resolveChosenService(attrs);

        if (serviceType === 'cueillette') {
          callback(true, null);
          return;
        }

        if (serviceType === 'transport' || serviceType === 'cle_en_main') {
          if (!deliveryCalcIsComplete(attrs)) {
            callback(
              false,
              'Vous avez choisi la livraison : entrez votre adresse et cliquez sur \u00ab Calculer et appliquer les frais \u00bb avant de payer (ou revenez \u00e0 la cueillette gratuite).'
            );
            return;
          }
        }

        callback(true, null);
      })
      .catch(function () {
        var serviceType = resolveChosenService({});
        var state = window.jgqDeliveryState || {};
        if (serviceType === 'transport' || serviceType === 'cle_en_main') {
          // Sans panier : bloquer si pas de calcul validé en mémoire
          if (state.valid !== true || !String(state.address || '').trim()) {
            callback(
              false,
              'Vous avez choisi la livraison : calculez les frais avant de payer (ou choisissez la cueillette).'
            );
            return;
          }
        }
        callback(true, null);
      });
  }

  window.JgqDeliveryCalculator = {
    validateBeforeCheckout: validateBeforeCheckout,
    isResidentialItem: isResidentialItem,
    isDeliveryFeeItem: isDeliveryFeeItem,
    checkResidential: checkResidential,
    init: initOnce
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOnce);
  } else {
    initOnce();
  }
})();
